import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import style from "./style";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import { CustomizedRadios, AttendanceRadio } from "./style"
import { useAlert } from "../../../../context/AlertContext";
import { useNavigate } from "react-router";
import { LoadingButton } from "@mui/lab";

const ModifyRolePermissionsPage = ({ permission, handleSubmit, disablePermission, role, loading, departmentData }) => {
  const [managePermission, setManagePermission] = useState(permission?.employee?.isView || permission?.employee?.isEdit);
  const [attendancePermission, setAttendancePermission] = useState(permission?.attendance?.isView || permission?.attendance?.isEdit || permission?.attendance?.isEditOwn || permission?.attendance?.isEditDepartment);
  const [leave, setLeave] = useState(permission?.leave?.isView || permission?.leave?.isEdit);
  const [recruitment, setRecruitment] = useState(permission?.recruitment?.isView || permission?.recruitment?.isEdit);
  const [roles, setRoles] = useState(permission?.permission?.isView || permission?.permission?.isEdit);
  const [payroll, setPayroll] = useState(permission?.payroll?.isView || permission?.payroll?.isEdit);
  const [timesheet, setTimesheet] = useState(permission?.timesheet?.isView || permission?.timesheet?.isEdit);
  const [salary, setSalary] = useState(permission?.salary?.isView || permission?.salary?.isEdit);
  const [payslip, setPayslip] = useState(permission?.payslip?.isView || permission?.payslip?.isEdit);
  const [deduction, setDeduction] = useState(permission?.deduction?.isView || permission?.deduction?.isEdit);
  const [loan, setLoan] = useState(permission?.loan?.isView || permission?.loan?.isEdit);
  const [account, setAccount] = useState(permission?.account?.isView || permission?.account?.isEdit);
  const [commission, setCommission] = useState(permission?.commission?.isView || permission?.commission?.isEdit || permission?.commision?.isView || permission?.commision?.isEdit)
  const [travelAllowance, setTravelAllowance] = useState(permission?.travelAllowance?.isView || permission?.travelAllowance?.isEdit)
  const [reports, setReports] = useState(permission?.reports?.isEdit)
  const [attendanceDepts, setAttendanceDepts] = useState(permission?.attendance?.departments || []);
  const [attendanceDeptError, setAttendanceDeptError] = useState("");

  // Helper to get attendance radio value
  const getAttendanceValue = (attendance) => {
    if (attendance?.scope === "all" || attendance?.isEdit) return "editAll";
    if (attendance?.scope === "department" || attendance?.isEditDepartment) return "editDept";
    if (attendance?.scope === "self" || attendance?.isEditOwn) return "editOwn";
    return "view";
  };

  const [attendanceValue, setAttendanceValue] = useState(getAttendanceValue(permission?.attendance));

  const [settings, setSettings] = useState({
    employee: { isView: permission?.employee?.isView, isEdit: permission?.employee?.isEdit },
    attendance: { isView: permission?.attendance?.isView, scope: permission?.attendance?.scope || "view", isEdit: permission?.attendance?.isEdit, isEditOwn: permission?.attendance?.isEditOwn, isEditDepartment: permission?.attendance?.isEditDepartment, departments: permission?.attendance?.departments || [] },
    leave: { isView: permission?.leave?.isView, isEdit: permission?.leave?.isEdit },
    recruitment: { isView: permission?.recruitment?.isView, isEdit: permission?.recruitment?.isEdit },
    permission: { isView: permission?.permission?.isView, isEdit: permission?.permission?.isEdit },
    payroll: { isView: permission?.payroll?.isView, isEdit: permission?.payroll?.isEdit },
    timesheet: { isView: permission?.timesheet?.isView, isEdit: permission?.timesheet?.isEdit },
    salary: { isView: permission?.salary?.isView, isEdit: permission?.salary?.isEdit },
    payslip: { isView: permission?.payslip?.isView, isEdit: permission?.payslip?.isEdit },
    deduction: { isView: permission?.deduction?.isView, isEdit: permission?.deduction?.isEdit },
    loan: { isView: permission?.loan?.isView, isEdit: permission?.loan?.isEdit },
    // pension: { isView: permission?.pension?.isView, isEdit: permission?.pension?.isEdit },
    account: { isView: permission?.account?.isView, isEdit: permission?.account?.isEdit },
    commission: { isView: permission?.commission?.isView || permission?.commision?.isView, isEdit: permission?.commission?.isEdit || permission?.commision?.isEdit },
    travelAllowance: { isView: permission?.travelAllowance?.isView, isEdit: permission?.travelAllowance?.isEdit },
    reports: { isView: false, isEdit: permission?.reports?.isEdit },
  });

  const { showAlert } = useAlert()

  const navigate = useNavigate();

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#28AA4A",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },

  }));

  const handleOption = (name, value) => {
    let isView = false;
    let isEdit = false;
    let isEditOwn = false;
    
    // Special handling for attendance - 4 options: view, editOwn, editDept, editAll
    if (name === "attendance") {
      if (typeof value === "boolean") {
        isView = value;
        isEdit = false;
        isEditOwn = false;
        setAttendanceValue("view");
        setAttendanceDepts([]);
        setAttendanceDeptError("");
      } else if (typeof value === "string") {
        if (value === "editAll") {
          isView = true; isEdit = true; isEditOwn = false;
          setAttendanceValue("editAll");
          setAttendanceDepts([]);
          setAttendanceDeptError("");
        } else if (value === "editOwn") {
          isView = true; isEdit = false; isEditOwn = true;
          setAttendanceValue("editOwn");
          setAttendanceDepts([]);
          setAttendanceDeptError("");
        } else if (value === "editDept") {
          isView = true; isEdit = false; isEditOwn = false;
          setAttendanceValue("editDept");
        } else {
          isView = true; isEdit = false; isEditOwn = false;
          setAttendanceValue("view");
          setAttendanceDepts([]);
          setAttendanceDeptError("");
        }
      }
    } else if (name === "reports") {
      // Special handling for reports - only allow edit permission, no view permission
      if (typeof value === "boolean") {
        // If value is boolean (from switch), use it directly as edit permission
        isView = false;
        isEdit = value;
      } else {
        // For reports, always set isView to false and only allow edit
        isView = false;
        isEdit = false;
      }
    } else {
      // For other modules, handle normally
      if (typeof value === "boolean") {
        // If value is boolean (from switch), use it directly
        isView = value;
        isEdit = false;
      } else if (typeof value === "string") {
        // If value is string (from radio button), convert to boolean
        const normalizedValue = value.trim().toLowerCase();
        isView = normalizedValue === "view" || normalizedValue === "edit";
        isEdit = normalizedValue === "edit";
      } else {
        // Fallback: treat truthy values as view enabled
        isView = !!value;
        isEdit = false;
      }
    }
    
    if (disablePermission?.permission?.isEdit) {
      setSettings(prevSettings => ({
        ...prevSettings,
        [name]: {
          isView: isView,
          isEdit: isEdit,
          ...(name === "attendance" && {
            scope: value === "editAll" ? "all" : value === "editOwn" ? "self" : value === "editDept" ? "department" : "view",
            isEditOwn: isEditOwn,
            isEditDepartment: value === "editDept",
            departments: value === "editDept" ? (prevSettings?.attendance?.departments || []) : [],
          })
        }
      }));
    } else {
      showAlert("Your are not Authorised", "error");
      return;
    }
  }

  const handleDepartmentsChange = (selectedDepts) => {
    setAttendanceDepts(selectedDepts);
    setAttendanceDeptError("");
    setSettings(prev => ({
      ...prev,
      attendance: { ...prev.attendance, isEditDepartment: true, departments: selectedDepts }
    }));
  };

  const submit = () => {
    if (attendanceValue === "editDept" && attendanceDepts.length === 0) {
      setAttendanceDeptError("Please select at least one department");
      return;
    }
    handleSubmit(settings);
  };
  
  const handleReset = () => {
    setSettings({
      "employee": { isView: false, isEdit: false },
      "attendance": { isView: true, scope: "view", isEdit: false, isEditOwn: false, isEditDepartment: false, departments: [] },
      "leave": { isView: true, isEdit: false },
      "recruitment": { isView: false, isEdit: false },
      "permission": { isView: false, isEdit: false },
      "payroll": { isView: false, isEdit: false },
      "timesheet": { isView: false, isEdit: false },
      "salary": { isView: false, isEdit: false },
      "payslip": { isView: false, isEdit: false },
      "deduction": { isView: false, isEdit: false },
      "loan": { isView: true, isEdit: false },
      // "pension": { isView: false, isEdit: false },
      "account": { isView: false, isEdit: false },
      "commission": { isView: false, isEdit: false },
      "travelAllowance": { isView: false, isEdit: false },
      "reports": { isView: false, isEdit: false }
    });

    setManagePermission(false);
    setAttendancePermission(true);
    setAttendanceValue("view");
    setAttendanceDepts([]);
    setAttendanceDeptError("");
    setLeave(true);
    setPayroll(false);
    setPayslip(false);
    setRecruitment(false);
    setRoles(false);
    setSalary(false);
    setTimesheet(false);
    setDeduction(false);
    setLoan(true);
    setAccount(false);
    setCommission(false)
    setTravelAllowance(false)
    setReports(false)
  };
  
  const handleNavigate = () => {
    navigate("/dashboard/rolesAndPermissions")
  }

  return (
    <>
      <Grid container>
        <Grid sx={style.mainBox}>
          <Box>
            <Typography variant="body1" sx={style.mainHeading}>
              Modify Roles and Permission
            </Typography>
          </Box>
          <Box sx={style.subheadingBox}>
            <Typography variant="body1" sx={style.customHeading}>
              Custom
            </Typography>
            <Box sx={style.line}></Box>
          </Box>
          <Box>
            <Box sx={style.sectionGrid}>
              <Box>
                <Box sx={style.lineTextGrid}>
                  <Box sx={style.permissionLine}></Box>
                  <Box>
                    <Typography variant="body1" sx={style.permissionHeading}>
                      Permission
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="success"
                  sx={
                    style.restoreButtons
                  }
                  disabled={!disablePermission?.permission?.isEdit}
                  onClick={() => handleReset()}
                >
                  Restore to Default
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid container sx={style.whiteSection}>
          <Grid item xs={12} lg={5} sx={style.gridBox}>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Manage Employees/Workers
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Can Manage Employees
                  </Typography>
                </Box>

                {managePermission && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("employee", value)} isEdit={permission?.employee?.isEdit} valueEdit={settings?.employee?.isEdit} /></Box>}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={managePermission} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setManagePermission(e.target.checked); handleOption("employee", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {managePermission ? "Yes" : "No"}
                </Typography>


              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Attendance Access
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Can Manage Attendance of All Employees
                  </Typography>
                </Box>
                {attendancePermission && (
                  <Box sx={style.radioSection}>
                    <AttendanceRadio 
                      onchange={(value) => handleOption("attendance", value)} 
                      value={attendanceValue}
                      disabled={!disablePermission?.permission?.isEdit}
                      departmentData={departmentData}
                      departments={attendanceDepts}
                      onDepartmentsChange={handleDepartmentsChange}
                      departmentError={attendanceDeptError}
                    />
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={attendancePermission} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setAttendancePermission(e.target.checked); handleOption("attendance", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {attendancePermission ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Leave Management
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Can Manage leave
                  </Typography>
                </Box>
                {leave && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("leave", value)} isEdit={permission?.leave?.isEdit} valueEdit={settings?.leave?.isEdit} /></Box>}

              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={leave} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setLeave(e.target.checked); handleOption("leave", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {leave ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Recruitment
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Recruitment
                  </Typography>
                </Box>
                {recruitment && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("recruitment", value)} isEdit={permission?.recruitment?.isEdit} valueEdit={settings?.recruitment?.isEdit} /></Box>}

              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={recruitment} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setRecruitment(e.target.checked); handleOption("recruitment", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {recruitment ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Roles and Permissions
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Roles and Permissions
                  </Typography>
                </Box>
                {roles && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("permission", value)} isEdit={permission?.permission?.isEdit} valueEdit={settings?.permission?.isEdit} /></Box>}

              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={roles} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setRoles(e.target.checked); handleOption("permission", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {roles ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Payroll Module
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Payroll Module
                  </Typography>
                </Box>
                {payroll && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("payroll", value)} isEdit={permission?.payroll?.isEdit} valueEdit={settings?.payroll?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={payroll} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setPayroll(e.target.checked); handleOption("payroll", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {payroll ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Timesheet
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Manage Timesheets
                  </Typography>
                </Box>
                {timesheet && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("timesheet", value)} isEdit={permission?.timesheet?.isEdit} valueEdit={settings?.timesheet?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={timesheet} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setTimesheet(e.target.checked); handleOption("timesheet", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {timesheet ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} lg={5} sx={style.gridBox}>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Salary Management
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Manage Salary
                  </Typography>
                </Box>
                {salary && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("salary", value)} isEdit={permission?.salary?.isEdit} valueEdit={settings?.salary?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={salary} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setSalary(e.target.checked); handleOption("salary", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {salary ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Payslip Generation
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Payslip Generation
                  </Typography>
                </Box>
                {payslip && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("payslip", value)} isEdit={permission?.payslip?.isEdit} valueEdit={settings?.payslip?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={payslip} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setPayslip(e.target.checked); handleOption("payslip", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {payslip ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Deduction
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Deduction Generation
                  </Typography>
                </Box>
                {deduction && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("deduction", value)} isEdit={permission?.deduction?.isEdit} valueEdit={settings?.deduction?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={deduction} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setDeduction(e.target.checked); handleOption("deduction", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {deduction ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>

            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Loan
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Loan Generation
                  </Typography>
                </Box>
                {loan && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("loan", value)} isEdit={permission?.loan?.isEdit} valueEdit={settings?.loan?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={loan} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setLoan(e.target.checked); handleOption("loan", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {loan ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Travel Claims
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Manage Travel Claims
                  </Typography>
                </Box>
                {travelAllowance && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("travelAllowance", value)} isEdit={permission?.travelAllowance?.isEdit} valueEdit={settings?.travelAllowance?.isEdit} /></Box>}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={travelAllowance} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setTravelAllowance(e.target.checked); handleOption("travelAllowance", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {travelAllowance ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Commissions
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Manage Commissions
                  </Typography>
                </Box>
                {commission && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("commission", value)} isEdit={permission?.commission?.isEdit} valueEdit={settings?.commission?.isEdit} /></Box>}

              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={commission} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setCommission(e.target.checked); handleOption("commission", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {commission ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Reports
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Manage Reports
                  </Typography>
                </Box>
                {reports && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("reports", value)} isEdit={permission?.reports?.isEdit} valueEdit={settings?.reports?.isEdit} hideView={true} /></Box>}

              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={reports} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setReports(e.target.checked); handleOption("reports", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {reports ? "Yes" : "No"}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.gridSubBox}>
              <Box sx={style.employeeName}>
                <Typography variant="body1" sx={style.permissionHeading}>
                  Accounts
                </Typography>
                <Box sx={style.greyText}>
                  <Typography variant="body1" sx={style.greyText}>
                    Account Setting
                  </Typography>
                </Box>
                {account && <Box sx={style.radioSection}><CustomizedRadios onchange={(value) => handleOption("account", value)} isEdit={permission?.pension?.isEdit} valueEdit={settings?.account?.isEdit} /></Box>}

              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch disabled={!disablePermission?.permission?.isEdit} checked={account} inputProps={{ "aria-label": "ant design" }} onChange={(e) => { setAccount(e.target.checked); handleOption("account", e.target.checked) }} />
                </Stack>
                <Typography variant="body1" sx={style.condition}>
                  {account ? "Yes" : "No"}
                </Typography>


              </Box>
            </Box>
          </Grid>

        </Grid>
        <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <LoadingButton loading={loading} variant="contained" disabled={!disablePermission?.permission?.isEdit} color="success" sx={style.jobButtons} onClick={() => submit()}>
              Save Changes
            </LoadingButton>
          </Box>
          <Box sx={style.createJob}>
            <Button variant="contained" sx={style.cancelButtons} onClick={handleNavigate}>
              Cancel
            </Button>
          </Box>

        </Box>

      </Grid >


    </>
  )
}
export default ModifyRolePermissionsPage;
